import { useForm } from 'react-hook-form';

import {
    Button,
    Card,
    colors,
    Page,
    Divider,
    ElvaLogoName,
    Input,
    Box,
    Text,
    u,
    WarningIcon,
    PasswordInput,
    CommitSha,
    Stack,
    Inline,
} from '@ui';

import { useBooth, useBoothLogin } from '../../hooks';

import * as css from './BoothLoginScreen.css';

type FormValues = {
    email: string;
    password: string;
};

export const BoothLoginScreen = () => {
    const { register, handleSubmit } = useForm<FormValues>();
    const { isError, error } = useBooth();
    const boothLogin = useBoothLogin();

    return (
        <Page>
            <Card>
                <Stack gap={u(2.5)}>
                    <Inline alignItems="center" justifyContent="space-between">
                        <Stack gap={u(0.5)}>
                            <h4>Device Configuration</h4>
                            <p style={{ fontSize: '0.8em', color: colors.gray[400] }}>Setup your device to continue</p>
                        </Stack>
                        <ElvaLogoName width={90} />
                    </Inline>
                    <Divider />
                    <form onSubmit={handleSubmit((data) => boothLogin.mutate(data))}>
                        <Inline alignItems="center" gap={u(8)}>
                            <Stack gap={u(2.5)} className={css.inputsContainer}>
                                {(isError || boothLogin.error) && (
                                    <span className={css.errorMessage}>
                                        {error?.message ?? boothLogin.error?.message}
                                    </span>
                                )}
                                <Input
                                    {...register('email')}
                                    required
                                    type="email"
                                    label="Device email address"
                                    placeholder="booth@elva.golf"
                                />
                                <PasswordInput
                                    {...register('password')}
                                    required
                                    label="Password"
                                    placeholder="Enter your password"
                                />
                                <Button
                                    type="submit"
                                    isLoading={boothLogin.isPending}
                                    isDisabled={boothLogin.isPending}
                                    variant="primary"
                                >
                                    Setup Device
                                </Button>
                            </Stack>
                        </Inline>
                    </form>
                    <Box display="flex" flexDirection="column" gap={u(1)} py={u(2.5)} px={u(2)} className={css.notice}>
                        <Box display="flex" gap={u(1)} alignItems="center">
                            <WarningIcon size={18} />
                            <Text variant="label">Warning</Text>
                        </Box>
                        <Text variant="p">
                            This is a device setup screen. <br /> If you're seeing this as a user, please contact your
                            local administrator.
                        </Text>
                    </Box>
                    <CommitSha />
                </Stack>
            </Card>
        </Page>
    );
};
